<template>
  <div class="source" v-if="creditCardInfo" v-loading="loading">
    <h3><i class="el-icon-bank-card" />選択中のクレジットカード</h3>
    <div class="card-container">
      <!-- <div class="card-container-item">
        <div class="title">有効期限(年)</div>
        <div class="content">{{creditCardInfo.exp_year}}</div>
      </div>
      <div class="card-container-item">
        <div class="title">有効期限(月)</div>
        <div class="content">{{creditCardInfo.exp_month}}</div>
      </div> -->
      <div class="card-container-item">
        <div class="title">カード番号（最後の4桁）</div>
        <div class="content">{{ creditCardInfo.last4 }}</div>
      </div>
      <!-- <div class="card-container-item">
        <div class="title">カードブランド</div>
        <div class="content">{{creditCardInfo.brand}}</div>
      </div> -->
      <div class="card-container-item">
        <div class="title">設定日時</div>
        <div class="content">
          {{ fbDateToString(creditCardInfo.addedAt.seconds * 1000) }}
        </div>
      </div>
      <div class="card-container-item">
        <div class="title">国</div>
        <div class="content">{{ creditCardInfo.country }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "@/plugins/firebase";
import { fbDateToString } from "@/utils/functions";
let updater;
export default {
  data() {
    return {
      creditCardInfo: null,
      loading: true
    };
  },
  methods: {
    fbDateToString
  },
  destroyed() {
    updater();
  },
  async mounted() {
    let self = this;
    const stripeUserSnapshot = await db
      .collection("StripeCustomers")
      .doc(self.$store.state.auth.user.uid)
      .collection("Sources")
      .get();
    stripeUserSnapshot.forEach(card => {
      self.creditCardInfo = card.data();
    });

    updater = await db
      .collection("StripeCustomers")
      .doc(self.$store.state.auth.user.uid)
      .collection("Sources")
      .onSnapshot(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
          self.creditCardInfo = doc.data();
        });
      });
    this.loading = false;
  }
};
</script>

<style lang="scss" scoped>
h3 {
  font-size: 0.9rem;
  margin: 0;
  margin-top: 5px;
  color: #444;
}
.source {
  min-height: 52px;
}

.card-container {
  display: flex;
  text-align: center;
  flex-direction: row;
  justify-content: space-evenly;
  width: 100%;
  &-item {
    display: flex;
    flex-direction: column;
    .title {
      font-size: 0.9rem;
      color: #333;
      font-weight: bold;
    }
  }
}
</style>
